import { Inject } from '@odinjs/odin';

import { ButtonAPI, FormAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnClose, OnValidate } from '@philips-emr/tws-core/lib/client';
import { ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, ModalRecuperarSenhaAliases, RootRoutes } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { ToastService } from '../../services';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.MODAL_RECUPERAR_SENHA })
export default class ModalRecuperarSenhaController extends BaseController {

  @Inject(ModalRecuperarSenhaAliases.PANEL_FORM)
  private panelForm: PanelAPI;
  @Inject(ModalRecuperarSenhaAliases.PANEL_AVISO)
  private panelAviso: PanelAPI;
  @Inject(ModalRecuperarSenhaAliases.FORM)
  private form: FormAPI;
  @Inject(ModalRecuperarSenhaAliases.BUTTON_CONFIRMAR)
  private buttonConfirmar: ButtonAPI;

  @OnClose(ModalRecuperarSenhaAliases.MODAL_RECUPERAR_SENHA)
  onClose = (): void => this.historyService.push(RootRoutes.ROUTE_LOGIN);

  @OnValidate(ModalRecuperarSenhaAliases.FORM)
  onValidate = ({ valid }: ValidateEvent): void => this.buttonConfirmar.setEnabled(valid);

  @OnClick(ModalRecuperarSenhaAliases.BUTTON_CONFIRMAR)
  onClick(): void {
    this.form.submit();
    if (this.form.isValid()) {

      this.setSubmitting(true);
      HttpService.post(Endpoints.POST.RECUPERAR_SENHA, {}, { body: this.form.getRecord() })
        .then(() => {
          this.panelForm.setVisible(false);
          this.panelAviso.setVisible(true);
        })
        .catch(response => {
          ToastService.open(response);
          this.setSubmitting(false);
        });
    }
  }

  private setSubmitting(value: boolean): void {
    this.form.setState({ submitting: value });
    this.buttonConfirmar.setState({ loading: value });
  }
}
